<script>
		import {user, game, view, send_data, send_request} from "../client.svelte.js";
		import {protoActions} from "../core.js";
		import {mapElement} from "../play/Encounter.svelte";
		import {onMount} from "svelte";
	  import OptionDialog, {show_actionCard, close_actionCard, starting} from "./OptionDialog.svelte";
	  import ActionCard from "../elements/ActionCard.svelte";
		import Select from "../elements/Select.svelte";

		let dialog      // this HTML element
		let { coord, location, options } = $props()

		let order = null			// will be set to option if one was selected on a touch device (no mouseover)
		let confirming = $state(false)
		let weapons = $derived(
		  view.persona.weapons
				.map(itemID => user.gearitems.get(itemID))
				.filter(item => item && item.ZUB === 'Weapon') )

		const moveOptions = {
			normal: ['gehen', 'laufen', 'sprinten'].map(moveID => protoActions[moveID]),
			special: ['springen', 'klettern', 'schwimmen'].map(moveID => protoActions[moveID]),
			hidden: ['schleichen', 'huschen'].map(moveID => protoActions[moveID]), }

		$inspect(`ACTION-MENU - options`, options)


		onMount( () => {
			dialog.showModal()
		})

		/** adjust position of dialog if not fully visible (incl action card) **/
		// ToDo: CSS position-anchor with position-try?  https://www.youtube.com/watch?v=dsD9bE_QVAs
		$effect( () => {
			if (view.option || dialog) {
				let excess
				const rect = dialog.getBoundingClientRect()
				// adjust left of dialog if too far right
				excess = Math.max(0, rect.right - window.screen.width)
				if (dialog.offsetLeft === 0 || excess > 0) {
						coord.x = coord.x - excess
						// dialog.style.left = coord.x - 8 + "px"
				}
				// adjust top of dialog if too low
				excess = Math.max(0, rect.bottom - window.screen.height)
				if (dialog.offsetTop === 0 || excess > 0)
						coord.y = coord.y - excess
						// dialog.style.top = coord.y - 8 + "px"
				}
		})


		function click_outside(e) {
				/// is also called when touch released 0.1s after showModel --> coord - 10px
				if (e.target.id === 'actionMenu')
						view.close_dialog()
		}

		function close_menu() {
				view.close_dialog()
				mapElement._touchEnd()
		}


		function hover_menu(e) {
				e.stopPropagation()
				e.preventDefault()
				if (this.action && view.option?.action !== this.action && !confirming) {
						view.option = Object.assign({}, this, protoActions[this.action], {radius: (this.aiming?.zone === 'Ball') ? this.aiming.limit / 2 : null})
				}
		}

		function leave_menu(e) {
				e.stopPropagation()
				if (view.option)
						view.option = null
		}


		function process_menu(e) {
			e.preventDefault()
			e.stopPropagation()
			// if (view.option?.action !== this.action) {
			// 	view.option = Object.assign({}, this, protoActions[this.action], {radius: (this.aiming?.zone === 'Ball') ? this.aiming.limit / 2 : null})
			// 	confirming = (e.pointerType === 'mouse') ? (['Umsehen', 'Verbergen'].includes(this.action) || this.aiming?.select === 'weap') : true
		  // 	return
	  	// }
			// some menu items require different treatment
			if (this.socket) {
				// instructions (e.g. APPEAR, TRANSFER, ...) or revisions are sent using a specialised socket event
		    send_request(this.socket, this)
				view.close_dialog()
				return
	    } else if (this.instruct) {     // ToDo: this belongs to a function higher up
				if (view.map.ID !== view.persona.position?.map && typeof this.target === 'string' && !(this.target.includes("_")))
					this.target += `_${view.map.ID}`
				send_request('instruct', this)
				view.close_dialog()
				return
		} else if (view.layout.page === 'deploy') {
				if (this.action === 'HEROES') {
						console.log(`ACTIONMENU: create deploy zone at position ${this.target}`)
						send_data(`/deploy/DEPLOY}`, {
							advtID: view.adventure.ID, sectID: view.section.SECT, charID: 'HEROES',
							callsign: "_", position: this.target, rank: 3,
							col: Math.round(this.target.col * 10) / 10, row: Math.round(this.target.row * 10) / 10
						})
				} else if (this.action === 'DEPLOY') {
						console.log(`ACTIONMENU: deploy ${this.charID} at position ${this.position}`)
						send_data(`/deploy/_`, this)
				}
				view.close_dialog()
				return
			}
			// generate normal order
			order = {action: this.action, aim: this.aim}
			view.option = Object.assign({}, this, protoActions[this.action], {radius: (this.aiming?.zone === 'Ball') ? this.aiming.limit / 2 : null})
			if (this.mark)
					Object.assign(order, {mark: this.mark, target: this.target ?? this.aim})

			// send order directly if move or entered by mouse
			const action$ = protoActions[this.action] ?? {}
			confirming = (e.pointerType === 'mouse') ?
					(['Umsehen', 'Verbergen'].includes(this.action) || this.aiming?.select === 'weap') :
					(!['Activity', 'Movement'].includes(action$.acttype) || this.aiming?.select === 'weap') && (!['INSERT', 'Wegpunkt', 'Versetzen'].includes(this.action))
			// console.log(`ACTION selected (${(confirming) ? "with confirming" : "without confirming"}): `, this, $state.snapshot(action$))
			if (!confirming) {
				start_action()
			}
		}

	  function start_action(risk) {
				if (risk)
						Object.assign(order, {risk: risk})
				game.place_order(order)
			  view.close_dialog()
		}


</script>


<!------------------------------- HTML ------------------------------------->

<dialog id=actionMenu data-help="options" bind:this={dialog} style:left="{coord.x - 10}px" style:top="{coord.y - 10}px"
        onclose={close_menu} onclick={click_outside}>
	<div class="menu-box">
		{#each Object.keys(options) as cat}
			<div>{cat}:
				<menu>
					{#each options[cat] as option}
						<li class="menu-item {option.execution} {option.kind} cost{option.exertion}" class:difficult={option.diffclt} class:disabled={option.disabled}
						    onmouseover={hover_menu.bind(option)} onpointerup={process_menu.bind(option)} >
							{option.label ?? option.action}
						</li>
					{/each}
				</menu>
			</div>
		{/each}
	</div>
	{#if view.option}
		<div class="card-box">
			<ActionCard action={view.option} />
			{#if confirming}
				{#if view.option.aiming?.select === 'weap'}
					<div class="weaponSelect">
						<Select field=weapon options={weapons} bind:value={order.aim} separate />
						<button class="button icon" onclick={() => start_action()} >
							<img src="/static/buttons/accept.png" alt="Start" title="Handlung starten" />
						</button>
					</div>
				{:else if view.option.acttype === 'Performance'}
					<div id="abilityFooter" class="cardFooter">
							{#each [2,3,4,5] as risk}
									<img class="skillBtns button icon" tabindex={risk-1} data-risk={risk}
											 src="/static/buttons/skill_{risk}dices.png" alt="{risk} W6*"
											 onclick={() => start_action(risk)}>
							{/each}
					</div>
				{:else}
					<button class="button icon d100" tabindex="1" data-risk="1" disabled={view.option?.disabled} onclick={() => start_action()} >
						<img src="/static/buttons/fight_dices.png" alt="D100" title="Wurf auf Fertigkeit" />
					</button>
				{/if}
				<div class="close fa icon-square-xmark" onclick={() => confirming = false}></div>
			{/if}
		</div>
	{/if}
</dialog>


<!------------------------------- STYLES ------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	#actionMenu
		display: grid
		grid-template-columns: auto auto
		grid-gap: 8px
		box-shadow: 2px 2px 30px lightgrey
		margin: 0
		color: colors.$white
		background-color: colors.$black
		padding: 4px
		transition: transform 0.2s, opacity 0.2s

	.menu-box
		background-color: colors.$grey-20
		padding: 0 8px
		list-style: none

		menu
			padding-left: 16px
			margin-block: 0 8px

	.menu-item
		display: block
		padding: 4px 8px
		width: 100%	/* max-content */
		transition: 0.1s
		color: colors.$white
		background-color: #404040

	.menu-item.proactive
		font-style: italic

	.menu-item.reactive
		font-weight: bold
		font-style: italic

	.menu-item:hover, .menu-item:focus
		filter: saturate(200%) opacity(200%) brightness(150%)
		cursor: pointer

	.menu-item.disabled
		text-decoration: line-through
		color: gray


	/*** action card ***/

	.card-box
		position: fixed
		left: 16px
		bottom: 16px
		background-color: colors.$grey-30

	.close
		position: absolute
		right: 0
		top: -8px
		float: right
		font-size: larger
		color: lightgray

	.close:hover
		color: lightcoral


	/*impactHue =hurt: 0, harm: 28, nerf: 56, heal: 120, save: 150, buff: 180, abil: 240, envm: 270, move: 300, chrg: 330}*/
	.menu-item.hurt
		--hue: 0
	.menu-item.harm
		--hue: 28
	.menu-item.nerf
		--hue: 56
	.menu-item.heal
		--hue: 120
	.menu-item.save
		--hue: 150
	.menu-item.buff
		--hue: 180
	.menu-item.abil
		--hue: 240
	.menu-item.envm
		--hue: 270
	.menu-item.move
		--hue: 300
	.menu-item.chrg
		--hue: 330

	.menu-item.cost, .menu-item.cost0
		background-color: hsl(var(--hue), 60%, 50%,  40%)
	.menu-item.cost5
		background-color: hsl(var(--hue), 65%, 50%,  50%)
	.menu-item.cost10
		background-color: hsl(var(--hue), 70%, 50%,  60%)
	.menu-item.cost15
		background-color: hsl(var(--hue), 75%, 50%,  70%)
	.menu-item.cost20
		background-color: hsl(var(--hue), 80%, 50%,  80%)
	.menu-item.cost25
		background-color: hsl(var(--hue), 85%, 50%,  90%)
	.menu-item.cost30
		background-color: hsl(var(--hue), 90%, 50%, 100%)

	.difficult
		color: lightgrey

	.d100
		position: absolute
		right: 20px
		bottom: 18px

	.weaponSelect
		margin: 8px
		display: grid
		grid-template-columns: 8ch auto 4em
		gap: 1em
		font-size: large

		label
			font-weight: bold

		.icon
			top: -12px

	.cardFooter
		background-color: colors.$grey-30
		display: flex
		justify-content: space-between
		gap: 24px
		padding: 0.5em 0.5em

</style>